
import { AfterViewInit, Directive, Input, OnDestroy, SkipSelf } from "@angular/core";
import { get as _get } from "lodash";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { CommonFieldManagerDirective } from "../field-manager.directive";
import { CommonFormManagerDirective } from "../form-manager.directive";

@Directive({
    selector: "[calculateSegmentsBasedOn]",
})
export class CalculateSegmentsDirective implements AfterViewInit, OnDestroy {
    @Input() public calculateSegmentsBasedOn: string;
    public formStateSubscriber$: Subscription;

    constructor(
        @SkipSelf() public formManager: CommonFormManagerDirective,
        public fieldManager: CommonFieldManagerDirective,
    ) { }

    public ngAfterViewInit() {
        this.formStateSubscriber$ = this.formManager.stateReplaySubject$.pipe(
            map((state: any) => _get(state, ["formData", this.calculateSegmentsBasedOn])))
            .subscribe((breakCount) => {
                const value = !!breakCount ? Number(breakCount) + 1 : 1;
                this.dispatchFieldUpdate(value);
            });
    }

    public ngOnDestroy() {
        this.formStateSubscriber$.unsubscribe();
    }

    public dispatchFieldUpdate(state) {
        this.fieldManager.dispatchFieldUpdate(state);
        this.fieldManager.dispatchFormFieldChange(state);
    }
}
